import { all } from 'redux-saga/effects'
import appSaga from './app/saga'

export default function* rootSaga(getState) {
  yield all([
    appSaga(),
  ])
}
